"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var datapoints_1 = require("./datapoints");
var createItemContextsForDeleteStoreUpdate_1 = require("./helpers/createItemContextsForDeleteStoreUpdate");
var deleteMailListRowsHelper_1 = require("./helpers/deleteMailListRowsHelper");
var handleBlockActionForShadowMailbox_1 = require("../actions/helpers/handleBlockActionForShadowMailbox");
var restoreItemService_1 = require("../services/restoreItemService");
var owa_analytics_1 = require("owa-analytics");
var owa_confirm_dialog_1 = require("owa-confirm-dialog");
var deleteItemsStoreUpdate_1 = require("owa-mail-actions/lib/triage/deleteItemsStoreUpdate");
var composeStore_1 = require("owa-mail-compose-store/lib/store/composeStore");
var owa_mail_focus_manager_1 = require("owa-mail-focus-manager");
var owa_mail_list_store_1 = require("owa-mail-list-store");
var Store_1 = require("owa-mail-list-store/lib/store/Store");
var deleteItemService_1 = require("owa-mail-store/lib/services/deleteItemService");
var Store_2 = require("owa-mail-store/lib/store/Store");
var undoActions = require("owa-mail-undo");
var doesFolderIdEqualName_1 = require("owa-session-store/lib/utils/doesFolderIdEqualName");
var owa_mail_strings_1 = require("owa-strings/owa-mail-strings");
var legacy_1 = require("satcheljs/lib/legacy");
var owa_mail_list_store_2 = require("owa-mail-list-store");
var owa_mail_actions_1 = require("owa-mail-actions");
function isReplyingToOneOfItems(itemIds) {
    var replyItemId = composeStore_1.default.defaultViewState && composeStore_1.default.defaultViewState.itemId;
    return replyItemId && itemIds.indexOf(replyItemId.Id) >= 0;
}
/**
 * The action worker which handles deleting the given items
 * Note: This aciton is exported only for unit testing purposes
 * @param itemIds - the conversation that need to be deleted
 * @param originalTableView - the table view the conversation should be deleted from
 * @param disposalType - the disposal type
 * @param parentFolderId - the parent FolderId
 * @param actionSource - the action source
 */
exports.deleteItemsWithoutConfirmDialog = legacy_1.action('deleteItemsWithoutConfirmDialog', datapoints_1.default.deleteItemsDatapoint)(function deleteItemsWithoutConfirmDialog(itemIds, disposalType, parentFolderId, actionSource, instrumentationContexts, requestInitOptions) {
    var itemContexts = createItemContextsForDeleteStoreUpdate_1.default(itemIds);
    // Dispatch action to update the store state
    deleteItemsStoreUpdate_1.default(itemContexts, parentFolderId);
    undoActions.clearLastUndoableAction();
    // Make service request
    var serviceItemIds = itemIds.map(function (itemIdValue) {
        return {
            Id: itemIdValue,
        };
    });
    deleteItemService_1.default(serviceItemIds, disposalType, requestInitOptions).then(function (responseItems) {
        if (disposalType === 'MoveToDeletedItems') {
            addDeletedItemsToUndoStack(responseItems);
        }
    });
    owa_mail_actions_1.userMailInteractionAction('Delete', instrumentationContexts);
});
exports.deleteItemFromReadingPane = legacy_1.action('deleteItemFromReadingPane')(legacy_1.select({
    item: function (itemId) { return Store_2.default.items.get(itemId.Id); },
})(function deleteItemFromReadingPane(itemId, disposalType, actionSource, instrumentationContexts, state) {
    // Early return if the action is blocked for shadow mailbox
    var sourceFolderId = state.item.ParentFolderId.Id;
    if (handleBlockActionForShadowMailbox_1.default(sourceFolderId, null)) {
        return;
    }
    var tableView = owa_mail_list_store_2.getSelectedTableView();
    var requestInitOptions = owa_mail_list_store_2.getMailboxInfo(tableView).requestOptions;
    var shouldUserConfirmDeletion = (disposalType == 'SoftDelete' &&
        doesFolderIdEqualName_1.default(state.item.ParentFolderId.Id, 'deleteditems')) ||
        (tableView && tableView.tableQuery.type == 2 /* Group */);
    owa_confirm_dialog_1.confirm('', owa_mail_strings_1.default.confirmDeletingItem, !shouldUserConfirmDeletion /*resolveImmediately*/, {
        // Wait until dialog is dismissed to avoid focus interruption
        delayCallbackAfterAnimation: true,
    }).then(function (response) {
        if (response == 0 /* ok */) {
            exports.deleteItemsWithoutConfirmDialog([itemId.Id], disposalType, sourceFolderId, actionSource, instrumentationContexts, requestInitOptions);
            owa_mail_focus_manager_1.resetFocus();
        }
    });
}));
/**
 * Initiates deleting of selected items
 * @param itemRowKeys - row keys to be deleted
 * @param originalTableViewId - the table view the conversation should be deleted from
 * @param isExplicitSoftDelete flag to indicate whether disposal type is soft delete
 * @param actionSource - the action source
 * @param state - some additional state required to complete the action
 */
exports.deleteItemsFromTable = legacy_1.select({
    originalTableView: function (conversationId, originalTableViewId) {
        return Store_1.default.tableViews.get(originalTableViewId);
    },
})(function deleteItemsFromTable(itemRowKeys, originalTableViewId, isExplicitSoftDelete, instrumentationContexts, actionSource, state) {
    var confirmDialogStrings = {
        deleteNumberOfRows: owa_mail_strings_1.default.deleteNumberOfItems,
        confirmDeleteRows: owa_mail_strings_1.default.confirmDeletingItems,
    };
    owa_analytics_1.logUsage(datapoints_1.default.deleteItemsFromTableDatapoint.datapoint.name, datapoints_1.default.deleteItemsFromTableDatapoint.datapoint.customData(itemRowKeys, originalTableViewId, actionSource));
    return deleteMailListRowsHelper_1.default(itemRowKeys, originalTableViewId, isExplicitSoftDelete, function (rowKeys, disposalType) {
        var rowIdStrings = owa_mail_list_store_1.getRowIdsFromRowKeys(rowKeys, originalTableViewId);
        exports.deleteItemsWithoutConfirmDialog(rowIdStrings, disposalType, state.originalTableView.tableQuery.folderId, actionSource, instrumentationContexts);
    }, isReplyingToOneOfItems, confirmDialogStrings);
});
function addDeletedItemsToUndoStack(responseItems) {
    var movedItemIds = [];
    for (var _i = 0, responseItems_1 = responseItems; _i < responseItems_1.length; _i++) {
        var responseItem = responseItems_1[_i];
        var deleteItemResponse = responseItem;
        if (deleteItemResponse.ResponseClass == 'Success') {
            movedItemIds.push(deleteItemResponse.MovedItemId.Id);
        }
    }
    if (movedItemIds.length > 0) {
        undoActions.addActionToUndoStack(function () {
            return restoreItemService_1.default(movedItemIds);
        });
    }
}
//# sourceMappingURL=deleteItems.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/orchestration/owa-mail-triage-action/lib/actions/deleteItems.js
// module id = 3192
// module chunks = 62